import { Link, useParams } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { SEO } from "../components/SEO";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/Motion";
import { getCounty, CITIES } from "../data/cities";
import { TOP_SERVICES } from "../data/services";
import NotFound from "./NotFound";

const CountyDetail = () => {
  const { citySlug } = useParams();
  const county = getCounty(citySlug);
  if (!county) return <NotFound />;
  const countyCities = CITIES.filter((c) => c.county.includes(county.name.split(" ")[0]));

  return (
    <main data-testid="county-detail-page">
      <SEO
        title={`Mobile Welding Repair in ${county.name}, TX | On-Site Welder`}
        description={`County-wide mobile welding repair across ${county.name}, TX — ${countyCities.map((c) => c.name).slice(0, 5).join(", ")} and more. Text a photo for a fast on-site quote.`}
      />
      <PageHero
        kicker={`County-wide coverage · County seat: ${county.seat}`}
        title={`Mobile welding repair across ${county.name}, TX`}
        lede={county.intro}
        testidPrefix="county"
      />
      <section className="bg-paper pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <Reveal>
            <div className="flex items-center gap-3 bg-cream border border-warmline p-5 mb-12 max-w-xl" data-testid="county-response">
              <Clock size={22} className="text-rust shrink-0" aria-hidden />
              <p className="text-[15px] text-smoke"><strong className="text-ink">Typical response:</strong> {county.response}.</p>
            </div>
          </Reveal>
          <h2 className="font-display font-extrabold tracking-tight text-2xl sm:text-3xl mb-8">Cities we serve in {county.name}</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-warmline border border-warmline mb-14" data-testid="county-cities">
            {countyCities.map((c, i) => (
              <Reveal key={c.slug} delay={(i % 3) * 0.05}>
                <Link to={`/service-areas/${c.slug}`} data-testid={`county-city-${c.slug}`} className="group block bg-cream hover:bg-sand transition-colors p-6 h-full">
                  <h3 className="font-display font-extrabold text-xl tracking-tight group-hover:text-rust transition-colors">{c.name}</h3>
                  <p className="mt-1 text-sm text-smoke">{c.tag} · on-site {c.response}</p>
                </Link>
              </Reveal>
            ))}
          </div>
          <h2 className="font-display font-extrabold tracking-tight text-2xl sm:text-3xl mb-8">Most-requested repairs in {county.name}</h2>
          <div className="grid sm:grid-cols-2 gap-px bg-warmline border border-warmline" data-testid="county-services">
            {TOP_SERVICES.map((s) => (
              <Link key={s.slug} to={`/services/${s.slug}`} data-testid={`county-service-${s.slug}`} className="group flex items-center justify-between gap-4 bg-cream hover:bg-sand transition-colors p-6">
                <div>
                  <h3 className="font-display font-bold text-lg tracking-tight group-hover:text-rust transition-colors">{s.name}</h3>
                  <p className="mt-1.5 text-sm text-smoke">{s.blurb}</p>
                </div>
                <ArrowRight size={18} className="text-rust shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden />
              </Link>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default CountyDetail;
